export const LOCALE_GET = 'LOCALE_GET'
export const LOCALE_SET = 'LOCALE_SET'
export const UPLOAD_USER_LOCALISATION = 'UPLOAD_USER_LOCALISATION'
export const TRANSLATED_DIFFERENCE = 'TRANSLATED_DIFFERENCE'
export const LOCALIZATION_MESSAGES_SET = 'LOCALIZATION_MESSAGES_SET'
export const LOCALIZATION_MESSAGES_DELETE = 'LOCALIZATION_MESSAGES_DELETE'
